import Promise from 'bluebird';
import _ from 'underscore';
import { verifyDepsExist } from '../utils/deps-check';

export class Decorator {
  constructor({ name, expectedDeps = [], deps = {} }) {
    if (!_.isString(name)) {
      throw new Error('Did not receive decorator name!');
    }

    this.name = name;
    verifyDepsExist(deps, expectedDeps);
  }

  getValueAsync() {
    return Promise.reject(new Error('Not implemented'));
  }

  // eslint-disable-next-line no-unused-vars
  buildQuery(queryParams, savedValue) {
    throw new Error('Not implemented!');
  }

  run(queryParams) {
    return this.getValueAsync().then(savedValue => this.buildQuery(queryParams, savedValue));
  }
}
